// extracted by mini-css-extract-plugin
export default {"form":"CodeAuth_form__43rhO","inputWrapper":"CodeAuth_inputWrapper__x+iTd","timerContainer":"CodeAuth_timerContainer__KfJ8n","resendButton":"CodeAuth_resendButton__o5ifb"};